import { Component, OnInit, Output, EventEmitter, Injector } from '@angular/core';
import { CookieService } from 'app/shared/services/cookie.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Constants } from 'app/core/models/constants';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { AuthService } from 'app/core/security/auth/auth.service';
import { AsideService } from 'app/layout/components/aside-container/aside.service';
import { ComponentItem } from 'app/shared/base/aside/component-item';
import { UserResetPasswordComponent } from 'app/layout/components/user-reset-password/user-reset-password.component';
import { SwitchCompanyComponent } from '../components/switch-company/switch-company.component';
import { UsersService } from 'app/modules/user-management/services/users.service';
import { TwoFactorComponent } from '../components/two-factor/two-factor.component';


@Component({ standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  loggedInUserName: string = '';
  loggedInFullName: string = '';
  currentCompanyName: string = '';
  currentCompanyCount: number;

  isOnline: boolean;

  @Output() toggleMenuEvent = new EventEmitter();

  get isAuthenticated(): boolean {
    return this.auth.isLoggedIn();
  }

  constructor(
    protected usersService: UsersService,
    private cookieService: CookieService,
    private router: Router,
    private route: ActivatedRoute,
    private apiDepenencies: ApiDependenciesService,
    private auth: AuthService,
    private asideService: AsideService,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.loggedInUserName = this.cookieService.getLoggedInUserName();
    this.currentCompanyName = this.cookieService.getLoggedInCompanyName();
    this.currentCompanyCount = this.cookieService.getKeyLoggedInCompanyCount();

    if (this.auth.companyCount > 1) {
      this.loggedInFullName = this.cookieService.getLoggedInFullName() + ' - ' + this.cookieService.getLoggedInContactName();
    }
    else {
      this.loggedInFullName = this.cookieService.getLoggedInFullName();
    }
  }

  logout(): void {
    this.cookieService.delete(Constants.Cookies.KeyAccessToken);
    this.cookieService.delete(Constants.Cookies.RefreshAccessToken);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInUserId);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInUserName);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInFullName);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInCompanyName);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInCompanyInboundRoutingNumber);
    this.auth.logout();

    this.router.navigateByUrl('/login');
  }

  refresh(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = function(){return false;};
    this.router.onSameUrlNavigation = 'reload';
    this.currentCompanyName = this.cookieService.getLoggedInCompanyName();
    this.router.navigateByUrl(this.router.url);
  }

  resetPassword(): void {
    const cookieValue = this.apiDepenencies.cookieService.get(Constants.Cookies.KeyLoggedInUserId);
    const loggedInUserId = + cookieValue;
    const userId: number = this.auth.loggedInUserId && this.auth.loggedInUserId !== -1 ? this.auth.loggedInUserId : loggedInUserId;

    this.asideService.setComponent(new ComponentItem(UserResetPasswordComponent, { itemId: userId, resetOwnPassword: true }));
    this.asideService.open();

    this.asideService.asideClose.subscribe(data => {
      if (data !== 'cancel') {
        this.logout();
      }
    });
  }
  
  twoFactor(): void {
    const cookieValue = this.apiDepenencies.cookieService.get(Constants.Cookies.KeyLoggedInUserId);
    const loggedInUserId = + cookieValue;
    const userId: number = this.auth.loggedInUserId && this.auth.loggedInUserId !== -1 ? this.auth.loggedInUserId : loggedInUserId;

    this.asideService.setAndOpen(new ComponentItem(
      TwoFactorComponent, {userId: userId}), this.injector);
  }

  switchCompany(): void {
    const cookieValue = this.apiDepenencies.cookieService.get(Constants.Cookies.KeyLoggedInUserId);
    const compCookieValue = this.apiDepenencies.cookieService.get(Constants.Cookies.KeyLoggedInCompanyId);

    const loggedInUserId = + cookieValue;
    const loggedInCompId = + compCookieValue;

    const userId: number = this.auth.loggedInUserId && this.auth.loggedInUserId !== -1 ? this.auth.loggedInUserId : loggedInUserId;
    const companyId: number = this.auth.loggedInCompanyId && this.auth.loggedInCompanyId !== -1 ? this.auth.loggedInCompanyId : loggedInCompId;

    this.asideService.setAndOpen(new ComponentItem(
      SwitchCompanyComponent, {userId: userId, companyId: companyId}), this.injector);
    this.asideService.asideClose.subscribe(data => {
      switch (data) {
        case 'error': {
          this.logout();
          break;
        }
        case 'cancel': {
          break;
        }
        default: {
          this.refresh();
          break;
        }
      }
    });
  }

  navigateToUserManagement() {
    this.router.navigate(['configuration/users']);
  }

  toggleMenu() {
    this.toggleMenuEvent.emit();
  }
}
